import classNames from 'classnames';
import { useState } from 'react';
import type { ContentItem } from '@hub/models/data';

type TabButtonProps = {
  active: boolean;
  onClick: () => void;
  title: string;
  headerWidth?: string;
};

const TabButton = ({ onClick, active, title, headerWidth }: TabButtonProps) => (
  <li>
    <button
      type="button"
      data-testid="tabs-button"
      onClick={onClick}
      className={classNames(
        'px-5',
        'block',
        'h-28',
        headerWidth || 'w-56',
        'items-center',
        'justify-center',
        'text-2xl',
        'items-end',
        'flex',
        'outline-none',
        'focus:outline-none',
        'cursor-pointer',
        active ? 'bg-gray-500 text-gray-0' : 'text-gray-500 hover:bg-gray-100'
      )}
      dangerouslySetInnerHTML={{ __html: title }}
    />
  </li>
);

export interface TabsProps {
  items: ContentItem[];
  headerWidth?: string;
  onTabButtonClick?: (index: number) => void;
}

export const Tabs = ({ items, headerWidth, onTabButtonClick }: TabsProps) => {
  const [activeTab, setActive] = useState(0);

  return (
    <div className="mt-16 w-full" data-testid="tabs-div">
      <ul className="flex flex-row border-b border-black mb-8">
        {items.map((item, index) => (
          <TabButton
            /* eslint-disable-next-line react/no-array-index-key */
            key={index}
            title={item.title}
            headerWidth={headerWidth}
            active={activeTab === index || activeTab === index}
            onClick={() => {
              if (index === activeTab || index === activeTab) {
                return;
              }

              setActive(index);
              if (onTabButtonClick) {
                onTabButtonClick(index);
              }
            }}
          />
        ))}
      </ul>
      {items.map((item, index) => (
        <div
          /* eslint-disable-next-line react/no-array-index-key */
          key={index}
          data-testid="tabs-pane"
          className={classNames(activeTab === index || activeTab === index ? '' : 'hidden')}
        >
          {activeTab === index && item.content}
        </div>
      ))}
    </div>
  );
};
